import api from '../services/api';
export const ProjectsModel = { 
    fetch: (language) => api.getProjects(language),
    fetchById:  (id, language) => api.getProject(id, language) // get project by id

    
};
